var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"timer"},[_c('span',[_vm._v(" "+_vm._s(_vm.countdownTime.hours)+" : "+_vm._s(_vm.countdownTime.mins)+" : "+_vm._s(_vm.countdownTime.secs)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }